<template>
    <div class="view view--startdesk-categories">
        <startdesk-categories-list v-bind:show-filters="{ 'search': true }"
                        v-bind:show-paging="true"
                        v-bind:show-sort="true"
        />
    </div>
</template>

<script>
    import startdeskCategoriesList from '../../../components/StartdeskCategoriesList.vue';

    export default {
        components: {
            startdeskCategoriesList
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/startdesks/categories/Index.vue